import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Fade,
  Grid,
  Icon,
  IconButton,
  TextField,
  useTheme,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import FormikContainer from "../../../../Components/Formik/FormikFormContainer/FormikContainer";
import ChartRenderer from "./ChartRenderer";
import useOrderCompareContainer from "../../DashboardChart/OrderCompareChart/components/useOrderCompareContainer";
import TotalChart from "../TotalChart";
import LoadingScreen from "../../../Organization/Chart/Components/LoadingScreen";
import useDeviceType from "../../../global/Hooks/useDeviceType";
import ClearIcon from "@mui/icons-material/Clear";
import useCheckDisplayChart from "../components/useCheckDisplayChart";
import TitleChart from "../components/TitleChart";
import { FilterIcon } from "lucide-react";
import FilterHandler from "../components/FilterHandler";

function OrderCompareChart() {
  const theme = useTheme().palette.mode;

  const {
    submitForm,
    data,
    dateList,
    lables,
    changeActiveFilterType,
    dataArea,
    activeFilterType,
    total,
    clearDatePicker,
    loading,
    setLoading,
  } = useOrderCompareContainer();
  const resetFormHandler = (reset) => {
    reset();
    setLoading(true);
  };
  const deviceType = useDeviceType();
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [loading]);
  /* -------------------------------- Accrdion -------------------------------- */
  const chartKey = "compareChart";
  const { displayChart } = useCheckDisplayChart(chartKey);
  const [filter, setFilter] = useState(false);

  return (
    <Box>
      {displayChart ? (
        <>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 2,
              marginBottom: "4px",
              flexWrap: "nowrap",
              overflowX: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
                padding: "0.5rem",
                flexWrap: "wrap",
              }}
            >
              <Button
                onClick={changeActiveFilterType}
                sx={{
                  color: theme === "dark" ? "#FFF" : "#262D39",
                  borderBottom:
                    activeFilterType === 1
                      ? "2px solid rgba(30, 106, 253, 1)"
                      : "",
                }}
              >
                {" "}
                تعداد تولیدشده
              </Button>
              <Button
                onClick={changeActiveFilterType}
                sx={{
                  color: theme === "dark" ? "#FFF" : "#262D39",
                  borderBottom:
                    activeFilterType === 2
                      ? "2px solid rgba(30, 106, 253, 1)"
                      : "",
                }}
              >
                {" "}
                مساحت تولیدشده
              </Button>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <TitleChart label={"مقایسه ای"} chartKey={chartKey} />
            </Box>
            <FilterHandler filter={filter} setFilter={setFilter} />{" "}
          </Box>
          {loading ? (
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                display: "flex",
                height: "5rem",
              }}
            >
              <LoadingScreen />
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                justifyContent:
                  deviceType == "mobile" ? "flex-start" : "space-between",
                alignItems: "center",
                flexDirection: deviceType == "mobile" ? "column" : "row",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  marginBottom: { md: "0", xs: "0.8rem" },
                  width: { md: "20%", xs: "100%" },
                }}
              ></Box>
            </Box>
          )}
          {filter && (
            <Fade in={filter} timeout={300}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <FormikContainer
                  initilaValue={dateList}
                  callbackData={(data) => submitForm(data)}
                  handleClose={() => {}}
                  disableActionForm={true}
                  formId="orderCompareChartForm"
                >
                  {({ values, setFieldValue, resetForm }) => {
                    useEffect(() => {
                      submitForm(values);
                    }, [values]);

                    return (
                      <Grid
                        container
                        spacing={1}
                        sx={{
                          marginTop: "0.5rem",
                          display: "flex",
                          backgroundColor:
                            theme == "light" ? "#E6F1FF" : "#161B25",
                        }}
                      >
                        <Grid
                          item
                          xs={6}
                          md={2}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <DatePicker
                            views={["year", "month"]}
                            label="نمودار اول"
                            value={values.date1}
                            onChange={(newValue) => {
                              setFieldValue("date1", newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                {...params}
                                helperText={null}
                              />
                            )}
                          />
                          <IconButton
                            onClick={() =>
                              clearDatePicker(setFieldValue, "date1")
                            }
                          >
                            <ClearIcon fontSize={"small"} color="error" />
                          </IconButton>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          md={2}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <DatePicker
                            views={["year", "month"]}
                            label="نمودار دوم"
                            value={values.date2}
                            onChange={(newValue) => {
                              setFieldValue("date2", newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                {...params}
                                helperText={null}
                              />
                            )}
                          />
                          <IconButton
                            onClick={() =>
                              clearDatePicker(setFieldValue, "date2")
                            }
                          >
                            <ClearIcon fontSize={"small"} color="error" />
                          </IconButton>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          md={2}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <DatePicker
                            views={["year", "month"]}
                            label="نمودار سوم"
                            value={values.date3}
                            onChange={(newValue) => {
                              setFieldValue("date3", newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                {...params}
                                helperText={null}
                              />
                            )}
                          />
                          <IconButton
                            onClick={() =>
                              clearDatePicker(setFieldValue, "date3")
                            }
                          >
                            <ClearIcon fontSize={"small"} color="error" />
                          </IconButton>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          md={2}
                          sx={{ display: "flex", justifyContent: "center" }}
                        >
                          <Button
                            sx={{ color: "red" }}
                            onClick={() => resetFormHandler(resetForm)}
                          >
                            <i
                              className="icon-Trash-Bin-2"
                              style={{ color: "red", marginLeft: "100px" }}
                            ></i>
                          </Button>
                        </Grid>
                      </Grid>
                    );
                  }}
                </FormikContainer>
              </Box>
            </Fade>
          )}
          <ChartRenderer
            dataLineChart={
              activeFilterType === 1
                ? data?.data?.data?.items
                : dataArea?.data?.data?.items
            }
            lables={lables}
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              alignItems: "center",
            }}
          >
            <TotalChart total={total} />
          </Box>
        </>
      ): <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <TitleChart label={"مقایسه ای"} chartKey={chartKey} />
            </Box>}
    </Box>
  );
}

export default OrderCompareChart;
